import { defineMessages } from 'react-intl';

const messages = defineMessages({
  unShippedItems: {
    description: 'orderDrawer.shippedItems',
    defaultMessage: 'Unshipped Items',
    id: 'EKI9e3',
  },
  itemsTitle: {
    description: 'groupByItem.itemTitle',
    defaultMessage: 'Items',
    id: 'nowBpV',
  },
  noItems: {
    description: 'groupByItem.noItems',
    defaultMessage: 'There are no items.',
    id: 'cVyz7j',
  },
  orderNumber: {
    description: 'sideBarItems.orderNumber',
    defaultMessage: 'Items from Order #{orderNumber}',
    id: 'P2LrGo',
  },
  defaultTitle: {
    description: 'sideBarItem.defaultTitle',
    defaultMessage: '{count, plural, one {Item} other {Items}}',
    id: 'yYBdjR',
  },
  quantity: {
    description: 'sideBarItem.quantity',
    defaultMessage: 'Qty',
    id: '3prNLp',
  },
  inventory: {
    description: 'sideBarItem.inventory',
    defaultMessage: 'Stock',
    id: 'WNd1UO',
  },
  groupByLabel: {
    defaultMessage: 'Group By:',
    description: 'groupByItemsSelector.title',
    id: 'GXhGC0',
  },
});

export default messages;
